import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IMunicipio } from '../model/municipio.model';

@Injectable()
export class MunicipioService extends EntityService<IMunicipio> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'municipio',
        urlBackend: configService.backendURL
      }
    );
  }
}
